export const createTableState = () => {
    return {
        loading: false,
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    }
}

export const normalizePagination = (meta) => {
    return {
        current: meta.current_page,
        pageSize: meta.per_page,
        total: meta.total_record,
    }
}